import { ActionSet, createActionSet } from '@futrli/shared-services';

export const SIGN_UP: ActionSet = createActionSet('SIGN_UP');

export const EXISTING_XERO_USER_MSG_KEY = 'error-existing-linked-user-xero';
